<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.OPTIONS.SELECTED"
    :handler="
      () =>
        $stores.services?.state?.transactionInitiation?.service?.id ==
          'subscription' &&
        $stores.services?.state?.transactionInitiation?.operation?.id ==
          'subscribe' &&
        $refs.modal.show()
    "
  />
  <DialogComponent ref="modal" type="bottomsheet" mainClass="fixed z-[52]">
    <div class="p-6 flex flex-col gap-8">
      <form class="w-full grid grid-cols-12 gap-4">
        <!-- Type d'abonnement -->
        <div class="col-span-12 flex flex-col">
          <label class="mb-1">Type d'abonnement</label>
          <select
            class="p-4 border rounded-xl border-neutral-200 focus:border-primary-400 w-full"
            v-model="
              $stores.services.state.transactionInitiation.subscriptionType
            "
          >
            <option value="netflix">Netflix</option>
            <option value="spotify">Spotify</option>
            <option value="prime">Amazon Prime</option>
            <option value="disney">Disney+</option>
            <option value="crunchyroll">Crunchyroll</option>
          </select>
        </div>

        <!-- Durée -->
        <div class="col-span-12 flex flex-col">
          <label class="mb-1">Durée</label>
          <select
            class="p-4 border rounded-xl border-neutral-200 focus:border-primary-400 w-full"
            v-model="$stores.services.state.transactionInitiation.duration"
          >
            <option value="1mois">1 mois</option>
            <option value="3mois">3 mois</option>
            <option value="6mois">6 mois</option>
            <option value="1an">1 an</option>
          </select>
        </div>

        <!-- Montant -->
        <div class="col-span-12 flex flex-col">
          <label class="mb-1">Montant</label>
          <input
            v-model="
              $stores.services.state.transactionInitiation.recipientAmount
            "
            type="number"
            class="p-4 border rounded-xl border-neutral-200 focus:border-primary-400 w-full"
            value="1000"
          />
          <small class="text-gray-500">Minimum : 1000 CFA</small>
        </div>

        <!-- Mode de paiement -->
        <div class="col-span-12 flex flex-col">
          <label class="mb-1">Comment payer</label>
          <select
            class="p-4 border rounded-xl border-neutral-200 focus:border-primary-400 w-full"
            v-model="$stores.services.state.transactionInitiation.paymentMethod"
          >
            <option
              v-for="(option, i) in $constants.SERVICES.PAYMENT_METHODS"
              :value="option"
            >
              {{ option.name }}
            </option>
          </select>
        </div>

        <!-- Numéro de téléphone -->
        <label
          class="grid py-3 items-center border border-neutral-200 bg-white rounded-3xl col-span-12"
        >
          <div class="flex flex-col px-4 col-span-4" required>
            <label class="mb-1 pl-1 flex justify-between items-center">
              <span>
                Téléphone
                <span class="text-red-800 text-xs pointer-events-none">
                  {{
                    $stores.services.state.transactionInitiation
                      .mobileMoneyOperationConfigs?.provider == 'none' &&
                    $stores.services.state.transactionInitiation.phoneOperator
                      ? $stores.services.state.transactionInitiation
                          .mobileMoneyOperationConfigs.launchErrorTitle
                      : ''
                  }}
                </span>
              </span>
            </label>
            <div class="relative flex items-center">
              <input
                v-model="
                  $stores.services.state.transactionInitiation.phoneNumber
                "
                required
                type="text"
                inputmode="numeric"
                pattern="[0-9]{8,}"
                class="w-full px-1 focus:outline-none"
                placeholder="Ex: 0161XXXXXX"
                ref="phoneNumberInput"
              />
              <div class="absolute right-2">
                <PhoneDetail
                  :phoneNumber="
                    $stores.services.state.transactionInitiation.phoneNumber
                  "
                  :countryCode="$stores.user.state.current?.countryCode"
                  @loading="
                    (data) => {
                      if ($refs.phoneNumberInput) $refs.phoneNumberInput.setCustomValidity('chargement');
                      $stores.services.state.transactionInitiation.phoneOperator =
                        '';
                    }
                  "
                  @resolved="
                    (data) => {
                      if ($refs.phoneNumberInput) $refs.phoneNumberInput.setCustomValidity('');
                      $stores.services.state.transactionInitiation.phoneOperator =
                        data.carrier;
                    }
                  "
                  @error="
                    (data) => {
                      $stores.services.state.transactionInitiation.phoneOperator =
                        '';
                      if ($refs.phoneNumberInput) $refs.phoneNumberInput.setCustomValidity(
                        `Erreur du numéro: ${data.error}`
                      );
                    }
                  "
                  v-slot="{ carrier }"
                >
                  {{ carrier }}
                </PhoneDetail>
              </div>
            </div>
          </div>
        </label>

        <!-- Email pour la confirmation -->
        <div class="col-span-12 flex flex-col">
          <label class="mb-1">Email</label>
          <input
            v-model="$stores.services.state.transactionInitiation.email"
            type="email"
            class="p-4 border rounded-xl border-neutral-200 focus:border-primary-400 w-full"
            placeholder="email@example.com"
          />
        </div>

        <!-- Bouton résumé -->
        <div class="col-span-12">
          <div
            class="p-4 rounded text-white"
            style="background-color: #354e92d4"
          >
            <div class="text-lg">Nous allons vous abonner</div>
          </div>

          <!-- Bouton submit -->
          <button
            class="mt-4 w-full flex items-center justify-center gap-2 text-white p-4 rounded"
            style="background-color: #354e92"
            type="button"
          >
            <span>Continuer</span>
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </button>
        </div>
      </form>
    </div>
  </DialogComponent>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MakePlatformSubscriptionForm'
});
</script>
